import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";

export default function UpdateIntakePopup({
  title, // Title of the popup
  isOpen, // Boolean to control popup visibility
  onClose, // Function to close the popup
  fetchIntakes, // Function to refresh the intake list
  updateIntake, // Function to update an intake
  data, // Intake data being edited
  degreeNames, // Added degreeNames prop
}) {
  const [intakeDetails, setIntakeDetails] = useState({
    id: "",
    alumniIntake: "",
    degreeProgram: "",
  });

  useEffect(() => {
    if (data) {
      setIntakeDetails({
        id: data.id || "",
        alumniIntake: data.alumni_intake || "",
        degreeProgram: data.degree_program || "", // Use 'degree_program' from your data
      });
    } else {
      setIntakeDetails({ id: "", alumniIntake: "", degreeProgram: "" });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIntakeDetails({ ...intakeDetails, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!intakeDetails.alumniIntake) {
      alert("Please enter an intake name.");
      return;
    }

    if (!intakeDetails.degreeProgram) {
      alert("Please enter degree.");
      return;
    }

    try {
      await updateIntake(intakeDetails.id, {
        alumniIntake: intakeDetails.alumniIntake,
        degreeProgram: intakeDetails.degreeProgram,
      });
      alert("Intake updated successfully!");
      onClose();
      fetchIntakes();
    } catch (error) {
      console.error("Error updating intake:", error);
      alert("Failed to update intake. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
      <div className="w-[500px] p-6 bg-white rounded-lg shadow-lg relative">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-700">{title}</h2>
          <button
            type="button"
            className="text-gray-500 border rounded-md shadow-md hover:text-gray-700"
            onClick={onClose}
          >
            <IoClose className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <div className="mb-4">
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="intake">
              Intake Name
            </label>
            <input
              id="alumniIntake"
              name="alumniIntake"
              type="text"
              value={intakeDetails.alumniIntake}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>

          <div className="mb-4">
            <label
              className="block mb-1 text-sm font-medium text-gray-600"
              htmlFor="degreeProgram"
            >
              Degree Program
            </label>
            <select
              id="degreeProgram"
              name="degreeProgram"
              value={intakeDetails.degreeProgram} // This is KEY to displaying the current value
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
            >
              <option value="">Select Degree</option>
              {degreeNames.map((degree) => (
                <option key={degree.id} value={degree.id}>
                  {degree.program_name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end gap-4">
            <button
              type="button"
              className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}